import "./index.less"
import Resume0 from '@/components/templates/Resume0'
import { Header } from "./components/header"
import { Footer } from "./components/footer"


const Index = () => {

  return (
    <div className="opcv-wrap">
      <Header />
      <Resume0 />
      <Footer />
    </div>
  )
}

export default Index